<template>
	<v-dialog v-model="dialog" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly"> 
	<v-doc-prop toolbar :fileItemId="dialogItemId" v-on:close="dialog = false"></v-doc-prop>
	</v-dialog> 
</template>

<script>
import vDocProp from './DocProp.vue'

export default {
  name: 'doc-dlg',
  components: {vDocProp},
  data: () => ({
    dialog: true,
    dialogItemId: null
  }),
  mounted () {
    this.dialogItemId = this.$route.params.uid ? this.$route.params.uid : null
  },
  watch: {
  // в случае изменения маршрута запрашиваем данные вновь
    '$route' () {
      this.dialogItemId = this.$route.params.uid ? this.$route.params.uid : null
      this.dialog = true
    }
  }

}
</script>



// WEBPACK FOOTER //
// DocDlg.vue?5aab3f63